module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "app-card-sidebar"
  }, [(_vm.$slots.button) ? _c('div', {
    staticClass: "app-card-sidebar__button"
  }, [_vm._t("button")], 2) : _vm._e(), _c('div', {
    staticClass: "app-card-sidebar__main"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6031e5c4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/layouts/cardlayouts/CardSidebarLayout/AppCardSidebarLayout.vue
// module id = 7c3fd87bd11a5053bcf6
// module chunks = 89